import React, { useState, useEffect } from 'react'
import './styles/switch.scss'

const Switch = (props) => {
    const {
        children, icon, style, onToggle, cssClass, isLeft, label, state, disabled,
        optimisticUpdate = true,
    } = props
    const [toggled, setToggled] = useState(false)

    useEffect(() => {
        setToggled(state || false)
    }, [state])

    const handleToggle = () => {
        if (optimisticUpdate) setToggled(!toggled)

        if (onToggle) {
            onToggle(!toggled)
        }
    }

    let componentClass = 'switch '
    componentClass += cssClass ? ` ${cssClass}` : ''

    let iconClass = 'icon '
    iconClass += toggled ? 'slide' : ''

    return (
        <div className={componentClass} onClick={!disabled ? handleToggle : null} aria-hidden>
            {isLeft && <div className="switch-label left">{label}</div>}
            <div className={`toggle-button ${toggled ? 'active' : ''} ${disabled ? 'disable' : ''}`} style={style}>
                <div className="slider">
                    {icon && <div className={iconClass}><i className={icon} /></div>}
                    {children}
                </div>
            </div>
            {(!isLeft) && <div className="switch-label right">{label}</div>}
        </div>

    )
}

export default Switch
